import axios from "../http";

class WarehouseManage {
  //仓库列表
  getWarehouseList(name) {
    const url = `/zwy/api/warehouse/list?name=${name}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //新增仓库
  postAddWarehouse(data) {
    const url = `/zwy/api/warehouse/add`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //编辑仓库
  postUpdateWarehouse(data) {
    const url = `/zwy/api/warehouse/update`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  //详情
  postDetailsWarehouse(id) {
    const url = `/zwy/api/warehouse/detail?id=${id}`;
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default WarehouseManage;
